export function racingConfig() {
    return {
        NextRaces: {
            swiper: {
                style: {
                    height: 'initial',
                    minHeight: '247px',
                    _mobile_padding: '0 8px 2px',
                },
            },
        },
    };
}
